import { gql } from '@apollo/client';

export const READ_PARKING_SESSION = gql`
  query ReadParkingSession($sessionId: ID!) {
    readParkingSession(sessionId: $sessionId) {
      sessionId
      transactionId
      startDate
      endDate
      corporateAccountUid
      predefinedTicketUid
      predefinedEndDate
      countryCode
      parkingZoneUid
      parkZone {
        uid
        name
        locationType
        commercialZoneView {
          name
          zoneCode
        }
        address {
          marker
        }
        info {
          doorCode
        }
        parkingMethods {
          anpr
        }
      }
      cardId
      accessDevice {
        value
      }
      customerSegment {
        uid
      }
      paymentState
      paymentType
      price {
        totalAmount
        vatAmount
        amountExclVAT
        vatPercentage
        breakdown {
          parkingFee {
            amountExclVAT
          }
          serviceFee {
            amountExclVAT
          }
        }
      }
      receipt {
        created
        refundHistory {
          refundedAmountCents
          timestamp
        }
      }
      changelog {
        created
        from {
          accessDevice {
            value
          }
        }
        to {
          accessDevice {
            value
          }
        }
      }
      poolingInfo {
        poolingGroupUid
        pooled
        customerGroupUid
        poolParkingType
        b2bCustomerUid
      }
      priceConfig {
        serviceFee {
          amount
          percent
          maxAmount
        }
      }
    }
  }
`;
